<template>
  <div>
    <p class="text-xl font-medium">2. Thông tin bổ sung</p>
    <v-expansion-panels multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Xem thông tin</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-0">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="value.facebookUrl"
                :rules="[rules.urlformat]"
                outlined
                color="#FBB040"
                prepend-inner-icon="mdi-facebook"
                label="Facebook"
              />
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="value.zaloUrl"
                :rules="[rules.urlformat]"
                outlined
                color="#FBB040"
                prepend-inner-icon="mdi-alpha-z-circle-outline"
                label="Zalo"
              />
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="value.description"
                outlined
                prepend-inner-icon="mdi-notebook"
                color="#FBB040"
                label="Ghi chú"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { required, email, urlformat } from "~/utils/validation";
import { mapState } from "vuex";

export default {
  name: "AdditionalInformation",
  props: {
    value: {
      type: Object,
      default: () => ({
        ethnic: 1,
        nationalityId: 232,
        identityCard: EMPTY,
        facebookUrl: EMPTY,
        business: EMPTY,
        zaloUrl: EMPTY,
        description: EMPTY,
      }),
    },
  },
  data() {
    return {
      rules: {
        required,
        email,
        urlformat,
      },
      evt: null,
    };
  },
  computed: {
    ...mapState(["ethnicList", "countryList"]),
  },
  watch: {
    value: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
  },
  methods: {
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
